// given a document element returns the xpath string expression of that element.
function getElementXPath(elt) {
  let path = '';
  for (; elt && (elt.nodeType === 1 || elt.nodeType === 3); elt = elt.parentNode) {
    if (elt.id) {
      let xname = elt.nodeType === 3 ? '' : elt.tagName;
      xname += "[@id='" + elt.id + "']";
      return '//' + xname + path;
    } else {
      let idx = getElementIdx(elt);
      let xname = elt.nodeType === 3 ? 'text()' : elt.tagName;
      if (idx > 1) xname += '[' + idx + ']';
      path = '/' + xname + path;
    }
  }

  return path;
}

function getElementIdx(elt) {
  let count = 1;
  for (let sib = elt.previousSibling; sib; sib = sib.previousSibling) {
    if (sib.nodeType === 1 && sib.tagName === elt.tagName) count++;
    if (sib.nodeType === 3 && sib.nodeType === elt.nodeType) count++;
  }

  return count;
}

function getFakeElementIdx(elt, nodeName) {
  let count = 1;
  for (let sib = elt.previousSibling; sib; sib = sib.previousSibling) {
    if (sib.nodeType === 1 && sib.tagName === nodeName) count++;
    if (sib.nodeType === 3 && sib.nodeName === nodeName) count++;
  }

  return count;
}

function getElementByXPath(xpath) {
  return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
}

export { getElementByXPath, getElementIdx, getElementXPath, getFakeElementIdx };
